export default "/images/hsbc-bank.png?ceec63d533271a3676933c0f01cade61";